import { useMutation, useQueryClient } from "@tanstack/react-query";
import { membershipApi } from "@bw/shared/api";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * Soft-cancel a subscription (DELETE /memberships/{id}) — cancel-at-period-end.
 * Access CONTINUES until current_period_end; the copy on the detail page says so.
 * The response is 204 (no body); both outcomes await list/detail/balance
 * revalidation, never an optimistic local flip of cancel_at_period_end.
 *
 * Errors surface on `mutation.error` for the detail page to show honestly — never
 * a fake "canceled".
 */
export function useCancelSubscription(subscriptionId: string | undefined) {
  const qc = useQueryClient();
  return useMutation<void, unknown, void>({
    mutationFn: () =>
      membershipApi.cancelSubscription(subscriptionId as string),
    onSettled: () => Promise.all([
      qc.invalidateQueries({ queryKey: queryKeys.memberships.mine() }),
      qc.invalidateQueries({ queryKey: queryKeys.memberships.detail(subscriptionId ?? "") }),
      qc.invalidateQueries({ queryKey: queryKeys.memberships.visitBalance(subscriptionId ?? "") }),
    ]),
  });
}
